module.exports = __webpack_public_path__ + "img/02.90104e4a.webp";